
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sharepoint",
      function () {
        return require("private-next-pages/destinations/sharepoint.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sharepoint"])
      });
    }
  